import styled from "styled-components";
import imgDesktop from "assets/images/orofacial/desktop.jpg";
import imgMobile from "assets/images/orofacial/mobile.jpg";

import { colors, colorScheme, fonts } from "styles";
export { Button } from "styles/styled-components";

export const Container = styled.a`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  padding: 0;
  height: 730px;
  background: url(${imgDesktop}) no-repeat top right;
  background-size: cover;
  cursor: pointer;
  @media screen and (max-width: 1300px) {
    max-height: 490px;
  }
  @media screen and (max-width: 1300px) {
    max-height: 490px;
  }
  @media screen and (max-width: 1050px) {
    background: url(${imgMobile}) no-repeat top center;
    background-size: cover;
    min-height: 1100px;
  }
  @media screen and (max-width: 580px) {
    background: url(${imgMobile}) no-repeat bottom center;
    background-size: cover;
    min-height: 620px;
  }
`;

export const AreaCta = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  max-width: 450px;
  height: auto;
  padding: 15px;
  z-index: 20;
  bottom: 220px;
  right: 15%;

  @media screen and (max-width: 1300px) {
    bottom: 100px;
  }
  @media screen and (max-width: 1050px) {
    bottom: 45px;
    right: inherit;
  }
  @media screen and (max-width: 580px) {
    bottom: 15px;
    right: inherit;
  }

  /* @media screen and (max-width: 1525px) {
    right: inherit;
    bottom: inherit;
    margin-bottom: 20px;
  } */
`;
export const GroupText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 50px;

  @media screen and (max-width: 1382px) {
    margin-bottom: 20px;
  }
  p {
    font-family: ${fonts.SourceSansProRegular};
    font-size: 18px;
    color: #fff;
    line-height: 1.4em;
  }
`;
export const GroupButtons = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  column-gap: 20px;
  align-items: center;
  justify-content: center;
`;
